module.exports = __webpack_public_path__ + "img/safe_car_1.89b0da49.png";